import "../vendor/progress.min.js";
import FuiModuleModifier from "./fui-module";

export default class FuiProgressModifier extends FuiModuleModifier {
  semanticModuleName = "progress";
}
